if(!customElements.get("collapse-content")){class CollapseContent extends HTMLElement{constructor(){super();this.initCl()}initCl(){this.collapseBtn=this.querySelector(".collapse-button")||this.querySelector("button");this.collapseExpand=this.querySelector("[collapse-content]");this.collapseEvent()}collapseEvent(){if(!this.collapseBtn)return;this.collapseBtn.addEventListener("click",()=>{const parent=this.parentElement;parent?.querySelectorAll("collapse-content.active").forEach(item=>{if(item!==this){const btn=item.querySelector(".collapse-button")||item.querySelector("button");const content=item.querySelector("[collapse-content]");btn?.classList.remove("active");content?.classList.remove("active");content?.closest(".collapse")?.classList.remove("active");item.classList.remove("active");if(content){content.style.maxHeight="0px"}}});if(this.collapseExpand.classList.contains("active")){this.collapseBtn.classList.remove("active");this.collapseExpand.classList.remove("active");this.collapseExpand.closest(".collapse")?.classList.remove("active");this.classList.remove("active");this.collapseExpand.style.maxHeight="0px"}else{this.collapseExpand.classList.add("active");this.collapseBtn.classList.add("active");this.collapseExpand.closest(".collapse")?.classList.add("active");this.classList.add("active");this.collapseExpand.style.maxHeight=this.collapseExpand.scrollHeight+40+"px"}})}}customElements.define("collapse-content",CollapseContent)}

if (!customElements.get("product-dropdown-readmore")) {
  class ProductDropdownReadmore extends HTMLElement {
    connectedCallback() {
      this.clip = this.querySelector("[data-readmore-clip]");
      this.body = this.querySelector("[data-readmore-body]");
      this.button = this.querySelector("[data-readmore-button]");
      this.label = this.querySelector("[data-readmore-label]");
      this.moreText = this.label?.getAttribute("data-readmore-more") || "";
      this.lessText = this.label?.getAttribute("data-readmore-less") || "";
      if (!this.clip || !this.body || !this.button) return;

      this.onToggle = this.toggle.bind(this);
      this.onMeasure = this.measure.bind(this);
      this.button.addEventListener("click", this.onToggle);

      this.resizeObserver = new ResizeObserver(() => this.scheduleMeasure());
      this.resizeObserver.observe(this.body);

      this.body.querySelectorAll("img").forEach((img) => {
        if (!img.complete) img.addEventListener("load", this.onMeasure, { once: true });
      });

      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.scheduleMeasure());
      }

      this.scheduleMeasure();
      setTimeout(() => this.measure(), 300);
    }

    disconnectedCallback() {
      this.button?.removeEventListener("click", this.onToggle);
      this.resizeObserver?.disconnect();
    }

    getClampPx() {
      const raw = (
        getComputedStyle(this).getPropertyValue("--product-dropdown-readmore-clamp") || "19.8rem"
      ).trim();
      if (raw.endsWith("rem")) {
        return parseFloat(raw) * parseFloat(getComputedStyle(document.documentElement).fontSize);
      }
      return parseFloat(raw) || 198;
    }

    scheduleMeasure() {
      cancelAnimationFrame(this.measureFrame);
      this.measureFrame = requestAnimationFrame(() => this.measure());
    }

    measure() {
      const clampPx = this.getClampPx();
      const full = this.body.scrollHeight;
      const needsClamp = full > clampPx + 12;
      const expanded = this.classList.contains("is-expanded");

      if (!needsClamp) {
        this.classList.remove("is-clamped", "is-expanded");
        this.button.hidden = true;
        this.button.setAttribute("aria-expanded", "false");
        this.clip.style.maxHeight = "";
        this.setLabels(false);
        this.syncPane();
        return;
      }

      this.classList.add("is-clamped");
      this.button.hidden = false;

      if (expanded) {
        this.clip.style.maxHeight = `${full}px`;
        this.button.setAttribute("aria-expanded", "true");
        this.setLabels(true);
      } else {
        this.clip.style.maxHeight = `${clampPx}px`;
        this.button.setAttribute("aria-expanded", "false");
        this.setLabels(false);
      }

      this.syncPane(expanded ? full : clampPx);
    }

    toggle() {
      const expanded = !this.classList.contains("is-expanded");
      const clampPx = this.getClampPx();
      const full = this.body.scrollHeight;

      this.classList.toggle("is-expanded", expanded);
      this.button.setAttribute("aria-expanded", expanded ? "true" : "false");
      this.setLabels(expanded);

      this.clip.style.maxHeight = `${expanded ? clampPx : full}px`;
      this.clip.offsetHeight;
      this.clip.style.maxHeight = `${expanded ? full : clampPx}px`;
      this.syncPane(expanded ? full : clampPx);
    }

    setLabels(expanded) {
      if (!this.label) return;
      this.label.textContent = expanded ? this.lessText : this.moreText;
    }

    syncPane(targetClipHeight) {
      const pane = this.closest(".collapse-content");
      if (!pane || !pane.classList.contains("active")) return;
      const clipHeight = this.clip.clientHeight || 0;
      const nextClip = targetClipHeight == null ? clipHeight : targetClipHeight;
      pane.style.maxHeight = `${pane.scrollHeight - clipHeight + nextClip + 48}px`;
    }
  }

  customElements.define("product-dropdown-readmore", ProductDropdownReadmore);
}
